package com.klantenstop.web.pages.company

import com.klantenstop.web.data.models.domain.Category
import com.klantenstop.web.data.models.domain.Company
import com.klantenstop.web.data.models.domain.Review
import com.klantenstop.web.data.models.domain.ReviewTotal
import com.klantenstop.web.data.models.domain.Status
import com.klantenstop.web.utils.MVI

interface CompanyContract : MVI<CompanyContract.State, CompanyContract.Intent, CompanyContract.Effect> {

    data class State(
        val companyIdentifier: String,
        val categories: List<Category> = emptyList(),
        val company: Company? = null,
        val reviews: List<Review> = emptyList(),
        val myReview: Review? = null,
        val reviewTotal: ReviewTotal = ReviewTotal(),
        val showUpdateCompanyStatusDialog: Boolean = false,
        val selectedStatusType: Status.Type = Status.Type.Unknown,
        val statusDescription: String = "",
        val showStatusDescription: Boolean = false,
        val hasAttemptedStatusSave: Boolean = false,
        val showCreateCompanyReviewDialog: Boolean = false,
        val showLoginRequiredDialog: Boolean = false,
        val isSavingReview: Boolean = false,
        val loading: Boolean = true,
        val companyNotFound: Boolean = false,
    ) {
        val userHasReview get() = myReview != null
    }

    sealed class Intent {
        data object LoadInitialData : Intent()
        data object ShowUpdateCompanyStatusDialog : Intent()
        data object HideUpdateCompanyStatusDialog : Intent()
        data object ShowCreateCompanyReviewDialog : Intent()
        data object HideCreateCompanyReviewDialog : Intent()
        data object ShowLoginRequiredDialog : Intent()
        data object HideLoginRequiredDialog : Intent()
        data class UpdateCompanyStatus(val companyStatus: Status.Type) : Intent()
        data class UpdateCompanyStatusDescription(val statusDescription: String) : Intent()
        data object ToggleStatusDescriptionVisibility : Intent()
        data object SaveCompanyStatusUpdate : Intent()
        data class SaveCompanyReview(val rating: Int, val reviewText: String) : Intent()
    }

    sealed class Effect
}
